import { listLogisticsOrders } from '@/modules/logistics/services/logisticsService';
import { todayIsoDate } from '@/modules/reservations/utils/dateRange';
import { addDays } from '@/modules/calendar/utils/dateRanges';

export type LogisticsDashboardStats = {
  pendingDeliveries: number;
  pendingPickups: number;
  inTransit: number;
  upcomingOperations: number;
};

const ACTIVE_STATUSES = new Set(['pending', 'scheduled', 'in_transit']);

export async function fetchLogisticsDashboardStats(): Promise<LogisticsDashboardStats> {
  const today = todayIsoDate();
  const until = addDays(today, 14);
  const orders = await listLogisticsOrders();

  const active = orders.filter(
    (o) => ACTIVE_STATUSES.has(o.status) && o.scheduledDate >= today,
  );

  return {
    pendingDeliveries: active.filter(
      (o) => o.type === 'delivery' && o.status === 'pending',
    ).length,
    pendingPickups: active.filter(
      (o) => o.type === 'pickup' && o.status === 'pending',
    ).length,
    inTransit: orders.filter((o) => o.status === 'in_transit').length,
    upcomingOperations: active.filter((o) => o.scheduledDate <= until).length,
  };
}
